import { useFormContext } from 'react-hook-form'

import { toISO8601 } from '@fortem-monorepo/js-utilities'
import { DatePicker } from '@fortem-monorepo/react-ui'
import { FormError } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'

export interface InitialObservationDateFieldProps {}

export const InitialObservationDateField: React.FC<InitialObservationDateFieldProps> = ({}) => {
  const { control, setValue } = useFormContext<{ initial_observation_date: string }>()

  return (
    <FormField
      name="initial_observation_date"
      control={control}
      render={({ field: { value } }) => {
        return (
          <FormItem>
            <div className="flex items-center gap-2">
              <FormLabel>Observation Date</FormLabel>
              <FormError />
            </div>
            <DatePicker
              placeholder={'Choose an observation date...'}
              selected={value ? new Date(value) : undefined}
              onSelect={(date) =>
                date &&
                setValue('initial_observation_date', toISO8601(date), { shouldValidate: true })
              }
            />
          </FormItem>
        )
      }}
    />
  )
}
